import '../lib/setup_jquery.js'

import Rails from '@rails/ujs'
Rails.start()

import '../lib/modernizr-custom.js'
import '../lib/jquery.datepicker.js'
import '../lib/jquery.ui.datepicker-ru.js'

import 'slick-carousel'
import '../lib/fotorama.js'

import '../lib/fb-sdk.js'

import '../lib/components/_variables.js'
import '../lib/components/_smart-resize.js'
import '../lib/components/_double-hover.js'
import '../lib/components/_toggle-text.js'
import '../lib/components/_sticky-footer.js'
import '../lib/components/_advertising_placement_pages.js'
import '../lib/components/_advertising_append_form.js'
import '../lib/components/_button_to_bottom.js'
import '../lib/components/_input-checkbox-radio.js'
import '../lib/components/_select.js'
import '../lib/components/_popup.js'
import '../lib/components/_content.js'
import '../lib/components/_header-nav.js'
import '../lib/components/_header-menu.js'
import '../lib/components/_header-subscription.js'
import '../lib/components/_search-overlay.js'
import '../lib/components/_main-slider.js'
import '../lib/components/_articles-default-slider.js'
import '../lib/components/_popular-materials-slider.js'
import '../lib/components/_events-calendar.js'
import '../lib/components/_left-menu.js'
import '../lib/components/_jobs.js'

import '../lib/project.js'
import '../lib/search.js'
import '../lib/poll.js'
import '../lib/radio.js'
import '../lib/form-trackable.js'
import '../lib/facebook_subscription.js'
import '../lib/branding.js'
import '../lib/banner_stats.js'
import '../lib/accept_cookies.js'
import '../lib/subscription.js'

